import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";
import { streamSse } from "@/lib/upload";

const SUGGESTIONS = ["Quale punto vendita ha più vincite?", "In quale fascia oraria si gioca di più?", "Quanti premi sono ancora da ritirare?", "Riassumi l'andamento degli ultimi giorni"];

export default function AiStatsPanel({ contestId }) {
  const [q, setQ] = useState("");
  const [model, setModel] = useState("gpt");
  const [out, setOut] = useState("");
  const [busy, setBusy] = useState(false);

  const ask = async (question) => {
    const text = question || q;
    if (!text.trim()) return;
    setQ(text);
    setBusy(true);
    setOut("");
    try {
      await streamSse(api.aiStatsUrl(), { question: text, model, contest_id: contestId || null }, (t) => setOut((o) => o + t));
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="p-5 bg-card border-border space-y-3 mt-6" data-testid="ai-stats-panel">
      <h3 className="font-display font-bold text-lg flex items-center gap-2"><Sparkles className="h-4 w-4 text-amber-400" /> Chiedi ai dati (AI)</h3>
      <div className="flex flex-wrap gap-2">
        {SUGGESTIONS.map((s) => (
          <button key={s} data-testid="ai-suggestion" onClick={() => ask(s)} className="text-xs rounded-full border border-border px-3 py-1 hover:border-primary hover:text-primary transition-colors">{s}</button>
        ))}
      </div>
      <div className="flex gap-2">
        <Input data-testid="ai-stats-input" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && ask()} placeholder="Fai una domanda sulle giocate e vincite…" />
        <select data-testid="ai-stats-model" value={model} onChange={(e) => setModel(e.target.value)} className="h-10 rounded-md border border-border bg-background px-2 text-sm">
          <option value="gpt">ChatGPT</option>
          <option value="claude">Claude</option>
          <option value="gemini">Gemini</option>
        </select>
        <Button data-testid="ai-stats-ask" onClick={() => ask()} disabled={busy} className="gap-2 shrink-0">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />} Chiedi
        </Button>
      </div>
      {out && <div data-testid="ai-stats-output" className="rounded-lg bg-secondary/40 p-4 text-sm whitespace-pre-wrap leading-relaxed">{out}</div>}
    </Card>
  );
}
